const Layout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "STATUS",
                "tableName": "",
                "label": "Status:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            } ,
            {
                "name": "RecordNumber",
                "tableName": "",
                "label": "Record#:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            }  
              ,
            {
                "name": "CreationDateTime",
                "tableName": "",
                "label": "Creation Auditable:",
                "type": "date",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "StatusInfo",
                "tableName": "",
                "label": "Status Info:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }
            ,
            {
                "name": "Value",
                "tableName": "",
                "label": "Field Value:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
             ,
            {
                "name": "TransmissionDate",
                "tableName": "",
                "label": "Transmission Date:",
                "type": "date",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    } ,
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ProcessName",
                "tableName": "",
                "label": "Process Name:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } ,
            {
                "name": "FieldName",
                "tableName": "",
                "label": "Field Name:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
            
           
        ]
    } ,
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "ProcessPage",
                "tableName": "",
                "label": "Process Page:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true


            } ,
            {
                "name": "User",
                "tableName": "",
                "label": "User:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }  
];
export default Layout;